import { Component, Input, QueryList, ContentChildren, AfterContentInit } from '@angular/core';

import { TabTitleDirective } from './tab-title.directive';
import { TabContentDirective } from './tab-content.directive';
import { PopupMenuItem } from '../../popup-menu/cog/popup-menu-item.model';

@Component({
    selector: 'aa-tab',
    template: '',
    standalone: false
})
export class TabComponent implements AfterContentInit
{
    @Input() id: number;
    @Input() title: string;
    @Input() tabRoute: string;
    @Input() activeWhen: string;
    @Input() active: boolean = false;
    @Input() disabled: boolean = false;
    @Input() soon: boolean = false;
    @Input() nuovo: boolean = false;
    @Input() subTabItems: PopupMenuItem[] = null;
    @ContentChildren(TabTitleDirective, { descendants: false }) titleTemplates: QueryList<TabTitleDirective>;
    @ContentChildren(TabContentDirective, { descendants: false }) contentTemplates: QueryList<TabContentDirective>;
    public titleTpl: TabTitleDirective | null;
    public contentTpl: TabContentDirective | null;

    ngAfterContentInit ()
    {
        this.titleTpl = this.titleTemplates.first;
        this.contentTpl = this.contentTemplates.first;
    }
}
